import { computed } from 'vue'
import { Extension } from '@/types/extension'
import store from '@/store/store'

export const allRealtimeExtensions = computed<Extension[]>(() => store.getters['extensions/extensionsWithCallStatus'])

